namespace RedBullMOBILE360.CustomerCare {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.CustomerCare.ManualResumeFraudCasesDialog')
    export class ManualResumeFraudCasesDialog extends Serenity.EntityDialog<ManualResumeFraudCasesRow, any> {
        protected getFormKey() { return ManualResumeFraudCasesForm.formKey; }
        protected getIdProperty() { return ManualResumeFraudCasesRow.idProperty; }
        protected getLocalTextPrefix() { return ManualResumeFraudCasesRow.localTextPrefix; }
        protected getNameProperty() { return ManualResumeFraudCasesRow.nameProperty; }
        protected getService() { return ManualResumeFraudCasesService.baseUrl; }
        protected getDeletePermission() { return ManualResumeFraudCasesRow.deletePermission; }
        protected getInsertPermission() { return ManualResumeFraudCasesRow.insertPermission; }
        protected getUpdatePermission() { return ManualResumeFraudCasesRow.updatePermission; }

        protected form = new ManualResumeFraudCasesForm(this.idPrefix);
    }
}
